import "./App.css";
import { AboutMe } from "./Components/About Me/AboutMe";
import { Contact } from "./Components/Contact/Contact";
import { Experience } from "./Components/Experience/Experience";
import { Footer } from "./Components/Footer/Footer";
import { Header } from "./Components/Header/Header";
import { Hero } from "./Components/Hero/Hero";
import { Projects } from "./Components/Projects/Projects";
import { Sidebar } from "./Components/Sidebar/Sidebar";

function App() {
  return (
    <div className="App">
      <div className="container">
        <Header />
        <Sidebar />
        <main className="mainContainer">
          <Hero />
          <AboutMe />
          <Experience />
          <Projects />
          <Contact />
          <Footer />
        </main>
      </div>
    </div>
  );
}

export default App;
